import PropTypes from 'prop-types';

// material-ui imports
import { Stack, Typography, TableCell } from '@mui/material';

// project imports
import FileMngrIconComponent from '../icon/FileMngrIconComponent';
import FileMngrTextHightlight from '../text-highlight/FileMngrTextHighlight';
import FileMngrItemTableRow from './FileMngrItemTableRow';
import { renderUser } from 'ui-component/fields/EntitySelect/admin/UserSelect';

const FileMngrTableRowItem = ({
    name,
    isFile,
    isSelected,
    onClick,
    onDoubleClick,
    format,
    isFMItemCutted,
    searchText,
    handlePaste,
    itemData,
    path,
    setIsLoading,
    setContextMenu,
    isSystemFolder
}) => {
    const ICON_SIZE = 20;
    const pathToDisplay = path.endsWith('/') ? path.slice(0, -1) : path;
    const thumbnailUrl = typeof itemData?.thumbnailUrl === 'string' ? itemData.thumbnailUrl.trim() : '';
    const getImageResolvedUrl = thumbnailUrl ? `${process.env.REACT_APP_API}${thumbnailUrl}` : null;

    const isImage = (filename) => {
        const imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
        const ext = String(filename ?? '')
            .split('.')
            .pop();
        return imageFormats.includes(ext.toLowerCase());
    };

    return (
        <>
            <FileMngrItemTableRow
                isSelected={isSelected}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                onContextMenu={(e) => {
                    if (!isSelected) onClick(e);
                    setContextMenu(e?.currentTarget);
                }}
                title={`${name} ${searchText?.length > 0 ? `(${pathToDisplay})` : ''}`}
                isFile={isFile}
                handlePaste={handlePaste}
                itemData={itemData}
                setIsLoading={setIsLoading}
            >
                <TableCell
                    sx={{
                        ml: -1,
                        opacity: isFMItemCutted && isFMItemCutted === true ? 0.65 : 1
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        mx={0}
                        sx={{ opacity: isFMItemCutted && isFMItemCutted === true ? 0.65 : 1 }}
                    >
                        <Stack width={ICON_SIZE} height={ICON_SIZE} direction="row" justifyContent="center" alignItems="center">
                            {isImage(name) && getImageResolvedUrl ? (
                                <Stack justifyContent="center" alignContent="center">
                                    <img
                                        src={getImageResolvedUrl}
                                        alt=""
                                        style={{ width: '100%', height: 'auto', bgcolor: 'transparent' }}
                                    />
                                </Stack>
                            ) : (
                                <FileMngrIconComponent isFile={isFile === true} iconSize={ICON_SIZE} format={format} />
                            )}
                        </Stack>
                        <Stack direction="row" alignItems="center" width="100%" flex="1" spacing={0.5}>
                            <Typography
                                variant="body2"
                                sx={{
                                    userSelect: 'none',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '100%',
                                    fontSize: 14,
                                    textAlign: 'left',
                                    display: 'block',
                                    color: isSystemFolder ? 'blue' : 'inherit'
                                }}
                            >
                                <FileMngrTextHightlight text={name} textToHighlight={searchText} color="yellow" />
                            </Typography>
                            {searchText?.length > 0 && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        userSelect: 'none',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '100%',
                                        fontSize: 12,
                                        textAlign: 'left',
                                        display: 'block',
                                        color: 'lightgray',
                                        fontStyle: 'italic'
                                    }}
                                >
                                    {pathToDisplay}
                                </Typography>
                            )}
                        </Stack>
                    </Stack>
                </TableCell>
                <TableCell>
                    <Typography
                        variant="inherit"
                        color="inherit"
                        sx={{
                            overflow: 'hidden',
                            display: 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {itemData?.dateCreated ? new Date(itemData?.dateCreated).toLocaleString() : ''}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography
                        variant="inherit"
                        color="inherit"
                        sx={{
                            overflow: 'hidden',
                            display: 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 80
                        }}
                    >
                        {renderUser(itemData?.createdBy, 'fullName')}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography
                        variant="inherit"
                        color="inherit"
                        sx={{
                            overflow: 'hidden',
                            display: 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {itemData?.dateModified || itemData?.updatedAt
                            ? new Date(
                                  itemData?.updatedAt ? `${itemData?.updatedAt?.replace(' ', 'T')}Z` : itemData?.dateModified
                              ).toLocaleString()
                            : ''}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography
                        variant="inherit"
                        color="inherit"
                        sx={{
                            overflow: 'hidden',
                            display: 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 100
                        }}
                    >
                        {renderUser(itemData?.updatedBy, 'fullName')}
                    </Typography>
                </TableCell>
            </FileMngrItemTableRow>
        </>
    );
};

FileMngrTableRowItem.propTypes = {
    name: PropTypes.string,
    isFile: PropTypes.bool,
    isSelected: PropTypes.bool,
    format: PropTypes.any,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    isFMItemCutted: PropTypes.bool,
    searchText: PropTypes.string,
    handlePaste: PropTypes.func,
    itemData: PropTypes.any,
    path: PropTypes.string,
    setIsLoading: PropTypes.func,
    setContextMenu: PropTypes.func,
    isSystemFolder: PropTypes.bool
};

export default FileMngrTableRowItem;
